var React = require('react');

function PauseInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Pause"),React.createElement("path",{"d":"M0.106445 14H3.34045V0.800003H0.106445V14ZM7.65605 14H10.89V0.800003H7.65605V14Z","key":1})]);
}

PauseInline.defaultProps = {"width":"11","height":"14","viewBox":"0 0 11 14","fill":"none","className":"icon"};

module.exports = PauseInline;

PauseInline.default = PauseInline;
